export default __webpack_public_path__ + "static/media/mag8.6b984bf5.png";